import React from 'react';
import { FieldData, LinkedProjectFieldType } from 'types/FieldTypes';
import { useModal } from 'components/modals/ModalContext';
import FieldWrapper from '../FieldWrapper';
import FieldViewMode from './elements/FieldViewMode';
import ProjectModal from '../../../views/jobs/ProjectModal';
import '../../../style/scss/live-edit.scss';
import '../../../style/scss/forms.scss';

/*
 * LinkedProjectField.tsx
 * Shows the project a document belongs to as a link which opens the
 * project modal, styled like the other linked object fields. The
 * field is read only, the project is linked when the document is
 * created from the project.
 */
const LinkedProjectField: React.FC<LinkedProjectFieldType & { data: FieldData, viewKey: string }> = ({
    name, label, data, tooltipText, helperText, alignment, isEditable
}) => {
    const { initializeModal } = useModal();

    // Get the linked project from the data
    const project = data?.[name];

    // Open the project modal on top of the current modal, without toggling the edit mode of the card
    const openProject = (event: React.MouseEvent) => {
        event.stopPropagation();
        if (!project?.id) return;
        initializeModal(<ProjectModal itemId={project.id} />, { modalSize: 'large-without-sidetab', itemId: project.id });
    };

    // Show the project name with its number between brackets
    const projectLabel = project ? `${project.name}${project.number ? ` (${project.number})` : ''}` : '';

    return (
        <FieldWrapper
            name={name}
            label={label}
            tooltipText={tooltipText}
            helperText={helperText}
            isEditable={isEditable}
            alignment={alignment}>
            {project && (
                <FieldViewMode
                    value={projectLabel}
                    type='link'
                    linkUrl={null}
                    onLinkClick={openProject}
                    alignment={alignment}
                />
            )}
        </FieldWrapper>
    );
};

export default LinkedProjectField;
